export default __webpack_public_path__ + "static/media/151023142717-cuba-valle-de-vinales-restr-super-169.0b0cd78f.jpg";